const profile = {
    name: '이름',
    avatar: '아바타',
    givenName: '이름',
    familyName: '성',
    middleName: '중간 이름',
    fullname: '전체 이름',
    nickname: '별명',
    preferredUsername: '선호하는 사용자명',
    profile: '프로필',
    website: '웹사이트',
    gender: '성별',
    birthdate: '생년월일',
    zoneinfo: '시간대',
    locale: '로케일',
    address: {
        formatted: '주소',
        streetAddress: '도로명 주소',
        locality: '도시',
        region: '주/도',
        postalCode: '우편번호',
        country: '국가',
    },
    gender_options: {
        female: '여성',
        male: '남성',
        prefer_not_to_say: '답하지 않음',
    },
    checkbox_value: {
        checked: '예',
        unchecked: '아니오',
    },
    avatar_upload: {
        upload: '업로드',
        remove: '제거',
        uploading: '업로드 중...',
        hint: '권장 크기 1:1, 최대 {{limit}}.',
        error_file_type: '파일 형식은 {{extensions}}이어야 합니다.',
        error_file_size: '파일 크기는 {{limit}}를 초과할 수 없습니다.',
        error_storage_not_configured: '사진을 업로드할 수 없습니다. 나중에 다시 시도해 주세요.',
        error_upload: '사진 업로드에 실패했습니다. 다시 시도해 주세요.',
        error_save: '사진을 저장하지 못했습니다. 다시 시도해 주세요.',
        crop_title: '사진 자르기',
        zoom: '확대/축소',
        error_crop: '이미지를 자르지 못했습니다. 다시 시도해 주세요.',
    },
};
export default Object.freeze(profile);
